import {
  Flex,
  useAuthenticator,
  useTheme,
  Link
} from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

export function SignInFooter() {
  const { toResetPassword } = useAuthenticator();
  const { tokens } = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    try {
      const forceReset = sessionStorage.getItem("forceResetPassword");
      if (forceReset === "true") {
        sessionStorage.removeItem("forceResetPassword");
        toResetPassword();
      }
    } catch {
      // sessionStorage not available; ignore
    }
  }, [toResetPassword]);

  return (
    // @ts-expect-error - AWS Amplify UI type definitions incorrectly require HTML input properties
    <Flex
      alignItems="center"
      direction="column"
      gap=".5rem"
      padding={tokens.space.small}
    >
      {/* @ts-expect-error - AWS Amplify UI type definitions incorrectly require HTML input properties */}
      <Link onClick={toResetPassword}>Forgot Password?</Link>
      {/* @ts-expect-error - AWS Amplify UI type definitions incorrectly require HTML input properties */}
      <Link
        onClick={() =>
          (window.location.href =
            "mailto:help@simpl.org?subject=Desktop Login Help")
        }
      >
        {t("Help & Support")}
      </Link>
    </Flex>
  );
}
